import Slider from 'react-slick';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import React from 'react';
import '../bem.css';

const data = require('../lang/lang.json');

function Platform9({match}) {
  const {id} = match.params
  const prefix = "platform"

  const text = data[localStorage.getItem('language')];
  const getData = (field) => data[prefix].state[id -1][field][localStorage.getItem('language')];

  const images = [
    `../images/${prefix}/${id}/1.jpg`,
    `../images/${prefix}/${id}/2.jpg`,
    `../images/${prefix}/${id}/3.jpg`,
    `../images/${prefix}/${id}/4.jpg`,
    `../images/${prefix}/${id}/5.jpg`
]
const enlargedImages = [
    `../images/${prefix}/${id}/1.jpg`,
    `../images/${prefix}/${id}/2.jpg`,
    `../images/${prefix}/${id}/3.jpg`,
    `../images/${prefix}/${id}/4.jpg`,
    `../images/${prefix}/${id}/5.jpg`
]
const next = "edmonHabetyan"
const slickerSettings = {
    customPaging: (i) => {
      if (i > 4) {
        return <div></div>;
      } else {
        return <button>i</button>;
      }
    },
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 500,
    centerPadding: '0',
    centerMode: true,
    centerMargin: '0',
    variableWidth: false,
    className: 'bem',
    adaptiveHeight: false,
    autoplay: false,
    dots: true,
    arrow: false,
    autoplaySpeed: 2500,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: '0',
          centerMode: true,
          centerMargin: '0',
          slidesToShow: 3,
          slidesToScroll: 0,
          adaptiveHeight: false,
          dots: true,
          arrow: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          centerPadding: '0',
          centerMode: true,
          centerMargin: '0',
          slidesToShow: 1,
          slidesToScroll: 0,
          adaptiveHeight: false,
          dots: true,
          arrow: false,
        },
      },
    ],
  };
  return (
    <section className='main-container current-container slider-centered'>
      <div className='breadcrumb current-inner-container'>
        <a href={`/${prefix}`}>{text.platform}/</a>
        <a href={getData('ref')} className='breadcrumb-active'>
        {getData('title')}
        </a>
      </div>
      <div className='section-details modal-slider slider-centered'>
        <div className='current-inner-container platform-inner'>
          <div className='row m-0 position-relative'>
            <div className='white-decoration'>
              <img src='../images/white-svg.svg' alt='asv' />
            </div>
            <div className='col-lg-5 pl-0 pr-0'>
              <img src={`../images/${prefix}/${id}/main.jpg`} alt='' />
            </div>
            <div className='main-description-banner col-lg-5'>
              <p className='row m-0'>{getData('title')}</p>
              <div className='info-block pre'>
                <p dangerouslySetInnerHTML={{ __html: getData('text') }}></p>
              </div>
            </div>
            <a href={`/${next}`} className='col-lg-1 p-0 next-page desktop-next'>
              <p> {text.next}</p>
              <img src='../images/arrow.svg' alt='' />
            </a>
          </div>
        </div>
        <Slider {...slickerSettings}>
        {images.map((image, index) =>
          <div data-toggle='modal' data-target='#GalleryModal' key={`${prefix}-${index}`}>
            <img
              src={image}
              alt=''
              data-target='#carouselGallery'
              data-slide-to={index}
            />
          </div>
          )}
        </Slider>
        <div className='modal fade' id='GalleryModal' tabIndex='-1' role='dialog' aria-hidden='true'>
          <div className='modal-dialog' role='document'>
            <div className='modal-content'>
              <div className='modal-header'>
                <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                  <span aria-hidden='true'>×</span>
                </button>
              </div>
              <div className='modal-body'>
                <div id='carouselGallery' className='carousel slide' data-ride='carousel'>
                  <div className='carousel-inner'>
                  {enlargedImages.map((image, index) =>
                    <div key={`${prefix}-large-${index}`} className={`carousel-item ${index ===0? 'active': ''}`}>
                      <img className='d-block w-100' src={image} alt='' />
                    </div>
                  )}
                  </div>
                  <a className='carousel-control-prev' href='#carouselGallery' role='button' data-slide='prev'>
                    <span className='carousel-control-prev-icon' aria-hidden='true'></span>
                    <span className='sr-only'>Previous</span>
                  </a>
                  <a className='carousel-control-next' href='#carouselGallery' role='button' data-slide='next'>
                    <span className='carousel-control-next-icon' aria-hidden='true'></span>
                    <span className='sr-only'>Next</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a href={`/${next}`} className='col-lg-1 p-0 next-page mobile-next'>
          <p> {text.next}</p>
          <img src='images/arrow.svg' alt='' />
        </a>
      </div>
    </section>
  );
}

const mapDispatchToProps = (dispatch) => ({
  setLanguage: (language) => dispatch({ type: 'SET_LANGUAGE', language }),
});

const mapStateToProps = (state) => {
  return { language: state.language };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Platform9))
